'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const fge=require('../../../../../dist-es6/client/extensions/flattenedGroupsExtensions');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

EditOrganizationUserGroupsModalController=(_dec=















































































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class EditOrganizationUserGroupsModalController extends BaseController{constructor($scope,$modalInstance,$modal,user,orgProfileData,availableGroups,userService,groupTreeService,socketService,uiCommandFactory,onUserUpdated,uncaughtErrorHandler){super(uncaughtErrorHandler);this._$scope=$scope;this._$modalInstance=$modalInstance;this._$modal=$modal;this._groupTreeService=groupTreeService;this._socketService=socketService;this._onUserUpdated=onUserUpdated;this._editUserGroupsCommand=uiCommandFactory.makeForModal($modalInstance,this._editCurrentUserGroups.bind(this));this.user=user;this.orgProfileData=orgProfileData;this.availableGroups=availableGroups;this.defaultGroupVisibilityString=orgProfileData.hideAllGroupsByDefault?'(No Groups)':'(All Groups)';this.query='';this.groupSettingType=_.get(user,'groupVisibilitySettings.visibleGroupIds')===null?'default':'custom';const displayNamesById=fge(availableGroups).getDisplayNamesById();this.visibleGroupIds=tryGet(user,'groupVisibilitySettings.visibleGroupIds').then(ids=>ids.map(id=>id===null?null:id.toString())).otherwise([]);this.enabledGroupsWithDisplayName=this.visibleGroupIds.filter(id=>displayNamesById.has(id)).map(id=>({displayName:displayNamesById.get(id),group:this.availableGroups.find(group=>id===group.id)}));this.availableGroupsWithDisplayName=this.availableGroups.map(group=>({displayName:displayNamesById.get(group.id),group}));this._role=user.role;this._isPrimary=user.isPrimary;this._isEditingSelf=this._email===_.get(userService,'currentUser.email')}transformChip(chip){if(angular.isObject(chip)){return chip}return{name:chip,type:'new'}}onCancel(){this._$modalInstance.dismiss()}get editUserGroupsCommand(){return this._editUserGroupsCommand}get submissionResult(){return this._submissionResult}async updateEnabledGroupsAndResetSearch(newSelectedGroupWithDisplayName){if(!newSelectedGroupWithDisplayName){return}this._$scope.$evalAsync(()=>{this.enabledGroupsWithDisplayName=_.uniqBy(this.enabledGroupsWithDisplayName.concat(newSelectedGroupWithDisplayName),'group.id');this.query=''})}getResultsForGroupsSearch(query){const groupsMatcher=new RegExp(_.escapeRegExp(query),'i');const visibleGroupIds=new Set(this.enabledGroupsWithDisplayName.map(g=>g.group.id));return this.availableGroupsWithDisplayName.filter(g=>groupsMatcher.test(g.displayName)&&!visibleGroupIds.has(g.group.id))}
async _editCurrentUserGroups(...args){
let editResult=await this._socketService.sendAndWaitForResponse('EditUserGroups',{
userId:this.user.id.toString(),
visibleGroupIds:this.groupSettingType==='default'?null:this.enabledGroupsWithDisplayName.map(g=>g.group.id)});


this._submissionResult=editResult;

if(!SocketResponse.succeeded(editResult)){
return ModalSubmissionResult.KeepOpen;
}

await this._onUserUpdated();

return ModalSubmissionResult.Close();
}

get role(){
return this._role;
}

get isPrimary(){
return this._isPrimary;
}

get isEditingSelf(){
return this._isEditingSelf;
}},(_applyDecoratedDescriptor(_class.prototype,'_editCurrentUserGroups',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_editCurrentUserGroups'),_class.prototype)),_class));


module.exports=EditOrganizationUserGroupsModalController;
//# sourceMappingURL=editOrganizationUserGroupsModalController.js.map
